import React, { Component } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import FsLightbox from "fslightbox-react";

import Header from "../Containers/Header";
import Modal from "../Components/Modal";
import Renditingimused from "./Renditingimused";
import FormSection from "../Components/FormSection";
import  { isBronPast, isBronActive }  from "../Utils/Functions";

const url =
  "https://www.skodalaagri.ee/sko/wp-content/themes/skodalaagri2017/rent/";
export default class Single extends Component { 
  constructor(props) {
    super(props);
    this.state = {
      carId: this.props.match.params.carID,
      car: null,
      bgImg: null,
      expanded: false,
      formModal: false,
      rentInfoModal: false,
      teenused: null,
      tarvikud: null,
      activeTarvik: null,
      activeTarvikModal: false,
      toggler: false,
      gallery: [],
      currentSlide: 0,
      isOpen: false,
    };
  }

  expandExtraEquipment() {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  }
  closeModal = () => {
    this.setState({
      formModal: false,
      rentInfoModal: false,
      activeTarvikModal: false,
    });
  };
  openModalForm = () => {
    this.setState({ formModal: true });
  };
  openRentForm = () => {
    this.setState({ rentInfoModal: true });
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    //fetch
    // console.log(this.props.match.params.carID);
    this.fetchCarInfo();
  }

  async fetchCarInfo() {
    const response = await fetch(
      `https://www.skodalaagri.ee/wp-json/acf/v3/rent/${this.props.match.params.carID}`
      //`http://skoda_laagri.localhost/wordpress/wp-json/acf/v3/rent/${this.props.match.params.carID}`
    );
    const model = await response.json();

    this.setState({ car: model["acf"] }, () => this.setImages());
  }

  setImages() {
    const { car } = this.state;
    //console.log("car", car.gallery[0].sizes.large)
    const img = car.gallery?.[0]?.sizes?.large;
    let randArray = [];
    Object.keys(car.gallery).map((image) => {
      //console.log("??--->", image, car.gallery[image].sizes.large);
      randArray[image] = car.gallery[image].sizes.large;
    });
    // console.log("randarray", randArray);
    this.setState({ bgImg: img, gallery: randArray });

    this.fetchExtraInfo();
  }
  async fetchExtraInfo() {
    // autorendi_lisatarvikud
    const response = await fetch(
      `https://www.skodalaagri.ee/wp-json/acf/v3/options/options_rent`
      //`http://skoda_laagri.localhost/wordpress/wp-json/acf/v3/options/options_rent`
    );
    const info = await response.json();
    //console.log(info.acf.autorendi_lisatarvikud);
    this.setState({
      teenused: info.acf.autorendi_teenused_hinnas,
      tarvikud: info.acf.autorendi_lisatarvikud,
    });
  }

  showImage = (slide) => {
    this.setState((prevState) => ({
      toggler: !prevState.toggler,
      currentSlide: slide,
    }));
  };

  closeGallery = () => {
    this.setState({
      isOpen: false,
    });
  };

  createImages = () => {
    const {
      car: { gallery },
    } = this.state;

    let counter = 0;
    return Object.keys(gallery).map((img) => {
      counter++;
      if (counter <= 3) {
        return (
          <img
            src={gallery[img].sizes.medium}
            alt=""
            onClick={() => this.showImage(parseInt(img) + 1)}
          />
        );
      } else {
        return false;
      }
    });
  };
  createEquipment = () => {
    const {
      car: { equipment },
    } = this.state;

    let split = equipment.split(/\r\n/);
    let eqSplited = [];

    return split.map((eq, i) => {
      eqSplited = eq.split(":");
      return (
        <li key={i} className="Single--stat">
          <span>{eqSplited[0]}</span>
          <span>{eqSplited[1]}</span>
        </li>
      );
    });
  };

  createExtraEquipment = () => {
    const {
      car: { extra_equipment },
    } = this.state;

    let split = extra_equipment.split(/\r\n/);

    return split.map((eq) => {
      return <li className="Single--stat">{eq}</li>;
    });
  };

  handleClick = (tarvik) => {
    let setVal = null;
    if (this.state.activeTarvik !== tarvik) {
      setVal = tarvik;
    }
    this.setState({ activeTarvik: setVal, activeTarvikModal: true });
  };

  render() {
    const { car, bgImg, teenused, tarvikud, toggler } = this.state;
    if (!car) {
      return "";
    }

    return (
      <>
        <div className="Single">
          <div className="Single--top">
            <div className="Single--top__main">
              <div className="Single--price">{car.price}€</div>
              <div className="Single--title">
                <h1>
                  <span className="make">{car.make.label}</span>{" "}
                  <span className="model">{car.model}</span>
                </h1>
                <p className="description">
                  {car.model_name}
                  {isBronActive(car) ? (
                    <span className="availability reserved">Broneeritud</span>
                  ):(
                    <span className="availability">Auto saadaval</span>
                  )}
                </p>
              </div>
            </div>
            <div className="Single--top__secondary"></div>
            <div className="Single--top__bg">
              <img src={`${bgImg}`} alt="" />
            </div>
          </div>

          <div className="Single--content">
            <div className="Single--side__main">
              <ul className="Single--tags">
                <li className="Single--tag">
                  <img src={`${url}images/fuel.png`} alt="Kütus" /> {car.fuel}
                </li>
                <li className="Single--tag__splitter"></li>
                <li className="Single--tag">
                  <img src={`${url}images/transmission.png`} alt="Käigukast" />{" "}
                  {car.transmission}
                </li>{" "}
                <li className="Single--tag__splitter"></li>
                <li className="Single--tag">
                  <img src={`${url}images/speed.png`} alt="Võimsus (kW)" />{" "}
                  {car.power} kW
                </li>
              </ul>
              <div className="Single--images">{this.createImages()}</div>
              <div className="Single--extrainfo">
                <h2>TEHNILISED ANDMED</h2>
                <ul className="Single--stats">{this.createEquipment()}</ul>

                <h2>VARUSTUS</h2>
                <ul
                  className={`Single--stats__extra${
                    this.state.expanded ? " expanded" : ""
                  }`}
                >
                  {this.createExtraEquipment()}
                </ul>
                <button
                  className="button button--primary"
                  onClick={() => this.expandExtraEquipment()}
                >
                  {this.state.expanded ? "Näita vähem" : "Näita rohkem"}
                </button>
              </div>
            </div>
            <div className="Single--side__secondary">
              <div className="Side">
                <h2>Autorendi teenused hinnas</h2>
                <ul>
                  {teenused &&
                    Object.keys(teenused).map((teenus) => {
                      return <li>{teenused[teenus].vaartus}</li>;
                    })}
                </ul>
                {car.make.value === "skoda" && tarvikud && tarvikud !== "" ? (
                  <>
                    <h2>Autorendi lisatarvikud</h2>
                    <ul class="clickable--features">
                      {tarvikud &&
                        Object.keys(tarvikud).map((tarvik) => {
                          return (
                            <li onClick={(e) => this.handleClick(tarvik)}>
                              <span class="header">
                                {tarvikud[tarvik].vaartus}
                              </span>
                              <div class="feature--content"></div>
                            </li>
                          );
                        })}
                    </ul>
                  </>
                ) : (
                  ""
                )}
                <button
                  className="button button--transparent"
                  onClick={() => this.openRentForm()}
                >
                  Renditingimused
                </button>
              </div>
              <div className="Price">
                <p>
                  Kuumakse <span className="text--tiny">(alates 1 kuu, sis. km 24%)</span>
                </p>
                <p className="Price--value">{car.price} €</p>
                {car.price7 || car.price14 || car.price21 ? (
                <div className="DayPrice">
                  Päeva hind rendi perioodil:
                  {car.price7 && <span>kuni 7 päeva <span>{car.price7} €</span></span>}
                  {car.price14 && <span>Kuni 14 päeva <span>{car.price14} €</span></span>}
                  {car.price21 && <span>Kuni 21 päeva <span>{car.price21} €</span></span>}
              </div>):""
              }
              </div>
             
              <button
                className="button button--special"
                onClick={() => this.openModalForm()}
              >
                Olen huvitatud
              </button>
              {/* open modal */}
            </div>
          </div>
        </div>

        <FsLightbox
          toggler={toggler}
          onClose={() => this.closeGallery()}
          initialAnimation="none"
          sources={this.state.gallery}
          slide={this.state.currentSlide}
        />

        {this.state.formModal ? (
          <Modal close={(e) => this.closeModal()}>
            <FormSection car={car} tarvikud={tarvikud} />
          </Modal>
        ) : (
          ""
        )}
        {this.state.rentInfoModal ? (
          <Modal close={(e) => this.closeModal()}>
            <Renditingimused />
          </Modal>
        ) : (
          ""
        )}
        {this.state.activeTarvikModal ? (
          <Modal close={(e) => this.closeModal()}>
            <h3>{tarvikud[this.state.activeTarvik].vaartus}</h3>
            <img
              src={tarvikud[this.state.activeTarvik].img.sizes.large}
              alt={tarvikud[this.state.activeTarvik].vaartus}
            />
            <div class="feature--content">
              <p>{tarvikud[this.state.activeTarvik].info}</p>
              <span className="feature--price">
                {tarvikud[this.state.activeTarvik].hind}.-{" "}
                <span className="feature--time">EUR/päev</span>
              </span>
            </div>
          </Modal>
        ) : (
          ""
        )}
      </> // Single END
    );
  }
}
